import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';

import './te-text';

/**
 * Dropdown Option Component
 *
 * @slot - Default slot for dropdown option content
 */
@customElement('te-dropdown-option')
export class TeDropdownOption extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .te-dropdown-option-slot {
        height: 40px;
        display: flex;
        align-items: center;
        width: 100%;
        color: ${theme.colors.text};
        padding: 16px;
        cursor: pointer;
      }

      .te-dropdown-option-slot.selected {
        background: ${theme.colors.primary.v0}0d;
      }

      .te-dropdown-option-slot.disabled {
        color: ${theme.colors.shade3};
        pointer-events: none;
      }

      .te-dropdown-option-slot:hover {
        background: ${theme.colors.shade1};
      }

      .te-dropdown-option-slot.no-hover:hover {
        background: transparent;
      }

      .te-dropdown-option-slot .image {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 8px;
        border: none;
        pointer-events: none;
      }

      .te-dropdown-option-slot.with-image {
        padding-left: 8px;
      }
    `,
  ];

  /** Value of the option */
  @property({ type: Number }) value = 0;
  /** Primary text value */
  @property({ type: String }) text = '';
  /** Option is disabled */
  @property({ type: Boolean }) disabled = false;
  /** Option is selected */
  @property({ type: Boolean }) selected = false;
  /** Source path / url of image for option  */
  @property({ type: String }) imageSource?: string;

  constructor(elem?: TeDropdownOption) {
    super();
    if (!elem) {
      return;
    }
    this.imageSource = elem.imageSource;
    this.text = elem.text;
  }

  render() {
    const classes = [
      'te-dropdown-option-slot',
      this.imageSource ? 'with-image' : '',
      this.selected ? 'selected' : '',
      this.disabled ? 'disabled' : '',
      this.parentElement?.className === 'display-text' ? 'no-hover' : '',
    ].filter(Boolean);

    return html`
      <div class="${classes.join(' ')}" @click=${this.handleClick}>
        ${this.imageSource
          ? html`
              <img class="image" src=${this.imageSource} />
            `
          : null}
        <te-text
          color=${this.disabled ? theme.colors.shade3.toString() : theme.colors.text.toString()}
        >
          ${this.text}
        </te-text>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-dropdown-option': TeDropdownOption;
  }
}
